/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Editor } from 'primereact/editor';
import { TabMenu } from 'primereact/tabmenu';
import { Panel } from 'primereact/panel';
import { Ripple } from 'primereact/ripple';
import { SplitButton } from 'primereact/splitbutton';
import { RadioButton } from 'primereact/radiobutton';
import { InputTextarea } from 'primereact/inputtextarea';

import ModalPreview from '@components/Section/ModalPreview'
import FileInput from '@components/FileInput';

import { SET_VALUES_SECTION } from '@constants/actionType';
import { LANGUAGE_DEFAULT } from '@constants/general';

import store from '@store';

class CapacitateEmpleo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIndex: 0,
      loadingPage: true,
      backgroundImg: [],
      languagePreview: [],
      errors: [],
      showModalPreview: {
        title: '',
        visible: false,
        children: ''
      }
    }
    this.initialValuesForm = {
        title: '',
        description: ''
    }
    this.initialValuesCardForm = {
      backgroundImg: [],
      btnHref: '',
    };
    this.initialValuesCardFormByLanguage = {
      title: '',
      btnText: '',
      description: '',
    };
  }

  componentDidMount() {
    const { keysLenguages, _capacitateEmpleo, itemsTabsLenguages, t } = this.props;
    if (_capacitateEmpleo) {
      this.setState({
        ..._capacitateEmpleo,
      });
    } else {
      keysLenguages.map((item) =>
        this.setState({ [item]: { ...this.initialValuesForm } })
      );
      let state = {
        cards: [{ ...this.initialValuesCardForm }]
      }
      keysLenguages.map((item) => {
        state.cards[0][item] = { ...this.initialValuesCardFormByLanguage }
      })
      this.setState({...state})
    }
    const languagePreview = itemsTabsLenguages.map((item) => {
      let label = t('En') + ' ' + item.label.replace(`(${t('Obligatorio')})`, '')
      return {
        label,
        icon: 'pi pi-eye',
        command: () => {
          this.onPreview(`${item.key}`)
        }
      }
    })
    this.setState({ languagePreview })
    this.setState({ loadingPage: false });
  }

  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  
  onChangeEditor = (names, e) => {
    const [language, name] = names.split('-');

    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: e.htmlValue },
    }), () => this.validateFieldsOnchange(names, e.htmlValue));
  };

  uploadFile = (files, isImage) => {
    const [file] = files;
    const { name: fileName } = file;
    const localUrl = URL.createObjectURL(file);
    const fileExtension = fileName.split('.').pop();
    const data = {
      fileName,
      currentValue: localUrl,
      file,
      fileExtension,
      isImage,
    };
    this.setState({ backgroundImg: [data] }, () => this.validateFieldsOnchange('backgroundImg', data));
  };

  removeFile = () => {
    this.setState({ backgroundImg: [] });
  };

  onChangeCard = ({target}) => {
    const [index, language, name] = target.name.split('-');
    const newCard = this.state.cards
    newCard[index][language][name] = target.value
    this.setState((prevState) => ({
      cards: newCard
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  onChangeCardSimple = ({target}) => {
    const [index, name] = target.name.split('-');
    const newCard = this.state.cards
    newCard[index][name] = target.value
    this.setState((prevState) => ({
      cards: newCard
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  uploadFileCard = (files, isImage, index) => {
    const [file] = files;
    const { name: fileName } = file;
    const localUrl = URL.createObjectURL(file);
    const fileExtension = fileName.split('.').pop();
    const data = {
      fileName,
      currentValue: localUrl,
      file,
      fileExtension,
      isImage,
    };
    const newCard = this.state.cards
    newCard[index].backgroundImg = [data]
    this.setState({ cards: newCard }, () => this.validateFieldsOnchange(`${index}-backgroundImg`, data));
  };

  removeFileCard = (index) => {
    const newCard = this.state.cards
    newCard[index].backgroundImg = []
    this.setState({ cards: newCard });
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { t } = this.props
    const { cards, backgroundImg } = this.state
    const { title, description } = this.state[LANGUAGE_DEFAULT]

    let errors = {}
    if (!title) errors = { ...errors, [`${LANGUAGE_DEFAULT}-title`]: `${t('Titulo sección')} ${t('es requerido')}` }
    if (!description) errors = { ...errors, [`${LANGUAGE_DEFAULT}-description`]: 'Descripción es requerido'}
    if (!backgroundImg.length) errors = { ...errors, [`backgroundImg`]: 'Imagen es requerido'}

    cards.map((item, index) => {
      if (!item.btnHref) errors = { ...errors, [`${index}-btnHref`]: `${t('Link')} ${t('es requerido')}` }

      if (!item[LANGUAGE_DEFAULT].title) errors = { ...errors, [`${index}-${LANGUAGE_DEFAULT}-title`]: `${t('Titulo')} ${t('es requerido')}` }
      if (!item[LANGUAGE_DEFAULT].btnText) errors = { ...errors, [`${index}-${LANGUAGE_DEFAULT}-btnText`]: `${t('Texto Botón')} ${t('es requerido')}` }
      if (!item[LANGUAGE_DEFAULT].description || item[LANGUAGE_DEFAULT].description === '\n') errors = { ...errors, [`${index}-${LANGUAGE_DEFAULT}-description`]: `${t('Descripción')} ${t('es requerido')}` }
    })
    this.setState({errors})
    return errors
  }

  onSubmit = async (e) => {
    e.preventDefault();
    let validate = await this.validateFields()
    if (some(validate, {})) return true
    const { success } = this.props
    await this.setValuesToStateGlobal()
    success();
  };

  setValuesToStateGlobal = async () =>  {
    const { cards, backgroundImg } = this.state
    const { keysLenguages } = this.props;
    const getValues = keysLenguages.reduce((accum, item) => {
      accum[item] = this.state[item];
      return accum;
    }, {});
    return await store.dispatch({
      type: SET_VALUES_SECTION,
      payload: { capacitateEmpleo: { ...getValues, cards, backgroundImg } },
    });
  }

  onPreview = async (language) => {
    await this.setValuesToStateGlobal()

    return this.setState({showModalPreview: {
      visible: true,
      language,
    }})
  }

  onHideModalPreview = () => {
    this.setState({showModalPreview: { visible: false }})
  }

  template = (options, index) => {
    const { t } = this.props;
    const getCards = this.state.cards;
    const toggleIcon = options.collapsed
      ? 'pi pi-chevron-down'
      : 'pi pi-chevron-up';
    const className = `${options.className} p-jc-beetween`;
    const titleClassName = `${options.titleClassName} p-pl-1`;

    return (
      <div className={className}>
        <div>
          <button
            type="button"
            className={options.togglerClassName}
            onClick={options.onTogglerClick}
          >
            <span className={toggleIcon} />
            <Ripple />
          </button>
          <span className={titleClassName}>
            {t('Card')} {index + 1} {t('de')} {getCards.length}
          </span>
        </div>
        { getCards.length !== 1 && (
          <div>
            <Button
              icon="pi pi-trash"
              type="button"
              className="p-button-text p-button-plain"
              onClick={() => this.removeService(index)}
            />
          </div>
        )}
      </div>
    );
  };

  addService = () => {
    const { keysLenguages } = this.props;
    const newCards = this.state.cards
    let stateCard =  [{ ...this.initialValuesCardForm }]
    keysLenguages.map((item) => {
      stateCard[0][item] = { ...this.initialValuesCardFormByLanguage }
    })
    newCards.push(stateCard[0])
    this.setState({ cards: newCards })
  };

  removeService = (index) => {
    const newCards = this.state.cards
    newCards.splice(index, 1)
    this.setState({ cards: newCards })
  };

  render() {
    const {
      t,
      btnSubmitLoading,
      itemsTabsLenguages,
      keysLenguages,
      onBack,
    } = this.props;
    const { activeTabIndex, loadingPage, showModalPreview, languagePreview, errors, backgroundImg  } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );
    
    const renderByTabLenguage = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      return (
        <>
          <div className="p-col-12 p-field">
            <label htmlFor="description" className="p-text-bold">
              {t('Titulo sección', {lng: prefixLenguage })}
            </label>
            <InputText
              name={`${prefixLenguage}-title`}
                type="text"
                value={this.state[prefixLenguage].title}
                onChange={this.onChange}
                autoFocus
                className={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-title`),
              })}
              />
            {getFormErrorMessage(`${prefixLenguage}-title`)}
          </div>
          <div className="p-col-12 p-field">
            <label htmlFor="description" className="p-text-bold">
              {t('Descripción', {lng: prefixLenguage })}
            </label>
            <Editor
              name={`${prefixLenguage}-description`}
              style={{ height: '200px' }}
              value={this.state[prefixLenguage].description}
              onTextChange={(e) =>
                this.onChangeEditor(`${prefixLenguage}-description`, e)
              }
              className={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-description`),
              })}
            />
            {getFormErrorMessage(`${prefixLenguage}-description`)}
          </div>
        </>
      );
    };

    const renderCards = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      const getCards = this.state.cards;
      return getCards.map((item, index) => (
        <div className="p-col-12" key={`card-${index}`}>
          <Panel
            headerTemplate={(e) => this.template(e, index)}
            collapsed={index >= 1}
            toggleable
          >
            <div className="p-fluid p-grid">
              <div className="p-col-12 p-md-6 p-lg-6" />
              <div className="p-col-12">
                {itemsTabsLenguages && (
                  <TabMenu
                    model={itemsTabsLenguages}
                    activeIndex={activeTabIndex}
                    onTabChange={(e) => this.setState({ activeTabIndex: e.index })}
                  />
                )}
              </div>
              <div className="p-col-12 p-field">
                <label htmlFor="title" className="p-text-bold">
                {t('Título', {lng: prefixLenguage })}
                </label>
                <InputText
                  name={`${index}-${prefixLenguage}-title`}
                  type="text"
                  value={this.state.cards[index][prefixLenguage].title}
                  onChange={this.onChangeCard}
                  autoFocus
                  className={classNames({
                    'p-invalid': isFormFieldValid(`${index}-${prefixLenguage}-title`),
                  })}
                />
                {getFormErrorMessage(`${index}-${prefixLenguage}-title`)}
              </div>
              <div className="p-col-12 p-field">
                <label htmlFor="btnText" className="p-text-bold">
                {t('Texto Botón', {lng: prefixLenguage })}
                </label>
                <InputText
                  name={`${index}-${prefixLenguage}-btnText`}
                  type="text"
                  value={this.state.cards[index][prefixLenguage].btnText}
                  onChange={this.onChangeCard}
                  className={classNames({
                    'p-invalid': isFormFieldValid(`${index}-${prefixLenguage}-btnText`),
                  })}
                />
                {getFormErrorMessage(`${index}-${prefixLenguage}-btnText`)}
              </div>
              <div className="p-col-12 p-field">
                <label htmlFor="description" className="p-text-bold">
                  {t('Descripción', {lng: prefixLenguage })}
                </label>
                <InputTextarea
                  name={`${index}-${prefixLenguage}-description`}
                  style={{ height: '200px' }}
                  value={this.state.cards[index][prefixLenguage].description}
                  onChange={this.onChangeCard}
                  className={classNames({
                    'p-invalid': isFormFieldValid(`${index}-${prefixLenguage}-description`),
                  })}
                />
                {getFormErrorMessage(`${index}-${prefixLenguage}-description`)}
              </div>
              <div className="p-col-12 p-md-12 p-lg-12">
                <div className="p-field">
                  <label className="p-text-bold">{t('Link')}</label>
                  <span className="p-input-icon-left">
                    <i className="pi pi-globe" />
                    <InputText
                      name={`${index}-btnHref`}
                      value={this.state.cards[index].btnHref}
                      onChange={this.onChangeCardSimple}
                      className={classNames({
                        'p-invalid': isFormFieldValid(`${index}-btnHref`),
                      })}
                    />
                  </span>
                  {getFormErrorMessage(`${index}-btnHref`)}
                </div>
              </div>
            </div>
          </Panel>
        </div>
      ));
    };

    if (loadingPage) return true;
    return (
      <>
        <form onSubmit={this.onSubmit} autoComplete="false">
          <div className="p-fluid p-grid p-mb-4">
            <div className="p-col-12 p-d-flex p-jc-end">
              {/* <Button
                label={t('Previsualizar')}
                icon="pi pi-eye"
                className="p-button-raised  p-button-info p-button-text"
                style={{ width: '130px' }}
                onClick={() => this.onPreview()}
                type="button"
              /> */}
            </div>
            <div className="p-col-12 p-md-6 p-lg-6">
              <FileInput
                onChangeFile={this.uploadFile}
                files={backgroundImg}
                removeAllFiles={this.removeFile}
                removeFile={this.removeFile}
                accept="/image*"
                txtDrop={t('Arrastra y suelta el archivo')}
                classNameBorderMain={classNames({
                  'p-invalid': isFormFieldValid('backgroundImg'),
                })}
              />
              {getFormErrorMessage(`backgroundImg`)}
            </div>
            <div className="p-col-12">
              {itemsTabsLenguages && (
                <TabMenu
                  model={itemsTabsLenguages}
                  activeIndex={activeTabIndex}
                  onTabChange={(e) =>
                    this.setState({ activeTabIndex: e.index })
                  }
                />
              )}
            </div>
            {renderByTabLenguage()}
            <div className="p-col-12 p-text-right p-d-flex p-jc-end">
              <Button
                label={t("Agregar card")}
                type="button"
                className="p-button-info"
                onClick={() => this.addService()}
                style={{width: '150px'}}
              />
            </div>
            {renderCards()}
          </div>
          <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Regresar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />
              <SplitButton
                label={t('Vista Previa')}
                icon="pi pi-eye"
                onClick={() => this.onPreview(keysLenguages[0])}
                className="p-button-primary"
                model={languagePreview}
              />
              <Button
                label={t('Continuar')}
                type="submit"
                className="p-button-primary"
                loading={btnSubmitLoading}
              />
            </div>
          </div>
        </form>
        <div>
          { showModalPreview.visible && (
            <ModalPreview
              language={showModalPreview.language}
              onHide={this.onHideModalPreview}
            />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  _capacitateEmpleo: state.section.capacitateEmpleo,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, null)
)(CapacitateEmpleo);
